import { Component } from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import { connect } from "react-redux";
import TableWithoutPagination from "../Table/TableWithoutPagination";

class MyBottlesTab extends Component {
	constructor(props) {
		super(props);

		this.state = {
			columns: [
				{
					Header: "Nom",
					Cell: ({row}) => {
						let liquidBottle = this.props.liquidBottlesAssignedToMe[
							row.index
						];

						if (!liquidBottle) return null;

						return (
							<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
								<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
									<span>{liquidBottle.name}</span>
								</div>
							</div>
						);
					},
				},
				{
					Header: "Code",
					Cell: ({row}) => {
						let liquidBottle = this.props.liquidBottlesAssignedToMe[
							row.index
						];

						if (!liquidBottle) return null;

						return (
							<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
								<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
									<span>{liquidBottle.product_code}</span>
								</div>
							</div>
						);
					},
				},
				{
					Header: "Quantité restante",
					Cell: ({row}) => {
						let liquidBottle = this.props.liquidBottlesAssignedToMe[
							row.index
						];

						if (!liquidBottle) return null;

						return (
							<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
								<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
									<span>{liquidBottle.stock_available}</span>
								</div>
							</div>
						);
					},
				},
				{
					Header: "Quantité net",
					Cell: ({row}) => {
						let liquidBottle = this.props.liquidBottlesAssignedToMe[
							row.index
						];

						if (!liquidBottle) return null;

						return (
							<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
								<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
									<span>{liquidBottle.stock_net}</span>
								</div>
							</div>
						);
					},
				},
				{
					Header: "Quantité réservée",
					Cell: ({row}) => {
						let liquidBottle = this.props.liquidBottlesAssignedToMe[
							row.index
						];

						if (!liquidBottle) return null;

						return (
							<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
								<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
									<span>{liquidBottle.stock_reserved}</span>
								</div>
							</div>
						);
					},
				},
				{
					Header: "Unité de mesure",
					Cell: ({row}) => {
						let liquidBottle = this.props.liquidBottlesAssignedToMe[
							row.index
						];

						if (!liquidBottle) return null;

						return (
							<div className="col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
								<div className="row col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding">
									<span>{liquidBottle.product_uom}</span>
								</div>
							</div>
						);
					},
				},
			],
		};
	}

	getTableTrProps(row) {
		if (row) {
			return {
				onClick: () => {
					this.props.searchLiquidBottle(row.original.name);
				},
                style: {
                    cursor: 'pointer'
                },
			};
		} else {
			return {};
		}
	}

	render() {
		return (
			<Card
				className={
					"card col-lg-12 col-md-12 col-sm-12 col-12 card-fluide without-side-margin"
				}
			>
				<CardContent
					className={
						"col-lg-12 col-md-12 col-sm-12 col-12 without-side-padding"
					}
				>
					<div className="col-lg-12 col-md-12 col-sm-12 col-12 control-margin-top">
						<TableWithoutPagination
							data={this.props.liquidBottlesAssignedToMe}
							columns={this.state.columns}
							minRows={5}
							getTrProps={this.getTableTrProps.bind(this)}
						/>
					</div>
				</CardContent>
			</Card>
		);
	}
}

const mapStateToProps = (state) => {
	return {
		liquidBottlesAssignedToMe: state.liquidBottles.liquidBottlesAssignedToMe,
	};
};

const mapDispatchToProps = () => {
	return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(MyBottlesTab);
